var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPinMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 9a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1M1 14a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1M1 19a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1M12 4a1 1 0 0 0 1 1l8 .001a1 1 0 1 0 0-2L13 3a1 1 0 0 0-1 1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21 10.586V5h-2v6.414l2 2V14h-8v-.586l2-2V5h-2v5.586l-1.56 1.56a1.5 1.5 0 0 0-.44 1.061V14.5a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-1.293a1.5 1.5 0 0 0-.44-1.06zM17 16h-1v3a1 1 0 1 0 2 0v-3z",
  clipRule: "evenodd"
})));
export default SvgIcPinMenu;